import { render, staticRenderFns } from "./referralInfo.vue?vue&type=template&id=58f99602&scoped=true&"
import script from "./referralInfo.vue?vue&type=script&lang=js&"
export * from "./referralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f99602",
  null
  
)

export default component.exports